import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../../utils/URLTools';

export const apiAssociateHandler = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'associateHandlerDefault',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      mrdName: payload.mrdName,
    },
  });
  return axios.post(serviceURL, {
    associateHandlerCommandList: [
      {
        handlerId: payload.associateHandlerCommandList.handlerId,
        handlerName: payload.associateHandlerCommandList.handlerName,
        printReceipt: payload.associateHandlerCommandList.printReceipt,
        validFrom: moment(payload.associateHandlerCommandList.validFrom).format('YYYY-MM-DD'),
        validTo: payload.associateHandlerCommandList.validTo !== undefined ? moment(payload.associateHandlerCommandList.validTo).format('YYYY-MM-DD') : null,
      },
    ],
  });
};
